export const DATE_RANGE_OPTIONS = [
	{ label: "Today", value: "today" },
	{ label: "This Week", value: "this_week" },
	{ label: "This Month", value: "this_month" },
	{ label: "Last 30 Days", value: "last_30_days" },
	{ label: "Custom Range", value: "custom" },
];

const toDateOnly = (date) => {
	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, "0");
	const day = String(date.getDate()).padStart(2, "0");
	return `${year}-${month}-${day}`;
};

const startOfWeekMonday = (date) => {
	const copy = new Date(date.getFullYear(), date.getMonth(), date.getDate());
	const day = copy.getDay();
	const diff = day === 0 ? 6 : day - 1;
	copy.setDate(copy.getDate() - diff);
	return copy;
};

export const resolveVisitDateRange = (dateRange, startDate, endDate) => {
	const normalizedRange = String(dateRange || "").trim().toLowerCase();
	if (!normalizedRange) {
		return { end: null, start: null };
	}

	const today = new Date();
	const todayStart = new Date(today.getFullYear(), today.getMonth(), today.getDate());

	if (normalizedRange === "today") {
		const value = toDateOnly(todayStart);
		return { end: value, start: value };
	}

	if (normalizedRange === "this_week") {
		return {
			end: toDateOnly(todayStart),
			start: toDateOnly(startOfWeekMonday(todayStart)),
		};
	}

	if (normalizedRange === "this_month") {
		return {
			end: toDateOnly(todayStart),
			start: toDateOnly(new Date(todayStart.getFullYear(), todayStart.getMonth(), 1)),
		};
	}

	if (normalizedRange === "last_30_days") {
		const start = new Date(todayStart);
		start.setDate(start.getDate() - 29);
		return { end: toDateOnly(todayStart), start: toDateOnly(start) };
	}

	if (normalizedRange === "custom") {
		return {
			end: endDate || null,
			start: startDate || null,
		};
	}

	return { end: null, start: null };
};

export const formatCustomRangeLabel = (startDate, endDate) => {
	if (!startDate && !endDate) return "Select dates";
	if (startDate && endDate) return `${startDate} – ${endDate}`;
	return startDate || endDate || "Select dates";
};

export const buildVisitQueryParams = ({
	currentPage,
	dateRange,
	debouncedSearch,
	endDate,
	organizationId,
	providerFilter,
	rowsPerPage,
	startDate,
	statusFilter,
}) => {
	const params = {
		limit: rowsPerPage,
		page: currentPage,
		...(organizationId ? { organizationId } : {}),
		...(debouncedSearch ? { search: debouncedSearch } : {}),
		...(statusFilter ? { status: statusFilter } : {}),
		...(providerFilter ? { providerId: providerFilter } : {}),
	};

	if (dateRange) {
		params.dateRange = dateRange;
		if (dateRange === "custom") {
			if (startDate) params.startDate = startDate;
			if (endDate) params.endDate = endDate;
		}
	}

	return params;
};

export const hasActiveVisitFilters = ({
	dateRange,
	debouncedSearch,
	endDate,
	providerFilter,
	startDate,
	statusFilter,
}) =>
	Boolean(
		debouncedSearch ||
			statusFilter ||
			providerFilter ||
			dateRange ||
			startDate ||
			endDate,
	);
